import { useState, useEffect } from 'react';
import { app } from '@microsoft/teams-js';

export const useTeamsContext = () => {
  const [userInfo, setUserInfo] = useState({
    userId: '',
    userPrincipalName: '',
    displayName: '',
    tenantId: ''
  });
  const [teamsLoading, setTeamsLoading] = useState(true);
  const [teamsError, setTeamsError] = useState('');

  useEffect(() => {
    const initializeTeams = async () => {
      try {
        // Initialize Microsoft Teams SDK
        await app.initialize();
        console.log('Teams SDK initialized');

        // Get user context
        const context = await app.getContext();
        console.log('Context received:', context);

        // Update user information
        setUserInfo({
          userId: context.user?.id || 'Not available',
          userPrincipalName: context.user?.userPrincipalName || 'Not available',
          displayName: context.user?.displayName || 'Not available',
          tenantId: context.user?.tenant?.id || 'Not available'
        });

        setTeamsLoading(false);

      } catch (error) {
        console.error('Error initializing Teams SDK or getting context:', error);
        setTeamsError('Failed to initialize Teams SDK or get user context: ' + error.message);
        setTeamsLoading(false);
      }
    };

    initializeTeams();
  }, []);

  return {
    userInfo,
    teamsLoading,
    teamsError
  };
};